import { Theme } from '@eversports/react-components/design-tokens/theme'
import RadioButton from '@eversports/react-components/primitives/RadioButton'
import { makeStyles } from '@mui/styles'
import React from 'react'

import { AdditionalPaymentMethodType, PaymentMethodVerificationMethod } from '../../typings/Payment'

import PaymentMethodIcon from './PaymentMethodIcon'

interface Props {
  paymentMethodType: AdditionalPaymentMethodType
  verifyWith: PaymentMethodVerificationMethod | null
  isSelected: boolean
  onClick?: () => void
}

const useStyles = makeStyles(({ borders, palette, borderRadii, layoutSpacing }: Theme) => ({
  hiddenRadioButton: {
    opacity: 0,
    width: 0,
    position: 'absolute',
    margin: layoutSpacing.none,
    height: '100%',
    display: 'none',
  },
  container: ({ isSelected }: { isSelected: boolean }) => ({
    border: borders.strong,
    borderColor: isSelected ? palette.primary.main : palette.divider,
    borderRadius: borderRadii.default,
    padding: `0 ${layoutSpacing.wide}`,
    marginRight: layoutSpacing.default,
    marginBottom: layoutSpacing.default,
    cursor: 'pointer',
  }),
}))

const AdditionalPaymentMethod = ({ paymentMethodType, verifyWith, isSelected, onClick }: Props) => {
  const classes = useStyles({ isSelected })

  return (
    <label className={classes.container}>
      <RadioButton name="type" value={paymentMethodType} className={classes.hiddenRadioButton} onClick={onClick} />
      <PaymentMethodIcon paymentMethodType={paymentMethodType} verifyWith={verifyWith} size="xx-large" />
    </label>
  )
}

export default React.memo(AdditionalPaymentMethod)
